module.exports = __webpack_public_path__ + "img/owealth.af56b7a1.png";